import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { FormControl } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { CpmService } from '../../service/cpm.service'
import { StoreService } from '../../service/store.service'
@Component({
  selector: 'app-ae-summary-visit-summary-by-team',
  templateUrl: './ae-summary-visit-summary-by-team.component.html',
  styleUrls: ['./ae-summary-visit-summary-by-team.component.scss']
})
export class AeSummaryVisitSummaryByTeamComponent implements OnInit {
  @Input() printPage
  @Output() changeYearByTeam: EventEmitter<string> = new EventEmitter()
  listTable
  listHeader
  checkConCase = false
  listTotalN = []
  listTotalC = []
  listCCTotal = []
  totalOfC
  totalOfN
  listYear
  selectedVisitSummaryByTeam
  yearControl = new FormControl()
  forTable = []
  listShowTable = []
  yearByTeam
  listPrint = []
  constructor(
    private store: StoreService,
    private cpmService: CpmService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.listYear = []
    const { yearByTeam } = this.activatedRoute.snapshot.params
    let year = new Date().getFullYear()
    for (let i = year - 2; i <= year; i++) {
      this.listYear.push(i)
    }
    this.listYear.sort((a, b) => 0 - (a > b ? 1 : -1))
    this.selectedVisitSummaryByTeam = this.listYear[0]
    if (yearByTeam !== undefined) {
      year = yearByTeam
    }

    this.yearControl.valueChanges.subscribe(value => {
      this.changeYearByTeam.emit(value)
    })

    this.yearControl.setValue(year)

    this.onChangeData()
    this.listHeader = [
      'Team',
      'Type',
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'July',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
      'Total'
    ]
  }
  onChangeData() {
    this.cpmService.getSummaryByTeam(this.yearControl.value).then(success => {
      this.listTable = []
      success.map(obj => {
        const lsData = {
          division: obj.division,
          teams: obj.team
        }
        this.listTable.push(lsData)
      })
      this.creatTableData()
      this.listPrint = []
      this.listShowTable.map(forPrint => {
        if (forPrint.cla === 'hide') {
          this.listPrint.push(forPrint)
        }
      })
    })
  }
  checkContinueCase(con) {
    return con === 'Continue case'
      ? (this.checkConCase = true)
      : (this.checkConCase = false)
  }
  forTotal(value) {
    return value.reduce((a, b) => a + b, 0)
  }
  changedEvent(event) {
    $(event.target)
      .parents()
      .next('.hide')
      .toggle()
  }
  createTable(data) {
    this.forTable = []
    if (data.division !== undefined) {
      data.teams.map(obj => {
        obj.numberOfCase.map(num => {
          const table = {
            team: obj.team,
            case: num.type,
            division: data.division
          }
          num.value.map((value, i) => {
            let key
            key = 'mont' + (i + 1)
            table[key] = value
          })
          table['total'] = this.forTotal(num.value)
          this.forTable.push(table)
        })
      })
    }
    return this.forTable
  }

  creatTableData() {
    this.listShowTable = []
    this.listTable.map(data => {
      let showData = Object.assign({}, data)
      showData['cla'] = 'labels'
      this.listShowTable.push(showData)
      showData = Object.assign({}, data)
      showData['cla'] = 'hide'
      showData['list'] = this.createTable(showData)
      const TotalOfTotalC = []
      const TotalOfTotalN = []
      const janN = []
      const febN = []
      const marN = []
      const aprN = []
      const mayN = []
      const juneN = []
      const julyN = []
      const augN = []
      const sepN = []
      const octN = []
      const novN = []
      const decN = []
      const janC = []
      const febC = []
      const marC = []
      const aprC = []
      const mayC = []
      const juneC = []
      const julyC = []
      const augC = []
      const sepC = []
      const octC = []
      const novC = []
      const decC = []
      showData['list'].map(total => {
        if (data.division === total.division) {
          switch (total.case) {
            case 'New case':
              janN.push(total.mont1),
                febN.push(total.mont2),
                marN.push(total.mont3),
                aprN.push(total.mont4),
                mayN.push(total.mont5),
                juneN.push(total.mont6),
                julyN.push(total.mont7),
                augN.push(total.mont8),
                sepN.push(total.mont9),
                octN.push(total.mont10),
                novN.push(total.mont11),
                decN.push(total.mont12)
              break
            case 'Continue case':
              janC.push(total.mont1),
                febC.push(total.mont2),
                marC.push(total.mont3),
                aprC.push(total.mont4),
                mayC.push(total.mont5),
                juneC.push(total.mont6),
                julyC.push(total.mont7),
                augC.push(total.mont8),
                sepC.push(total.mont9),
                octC.push(total.mont10),
                novC.push(total.mont11),
                decC.push(total.mont12)
              break
          }
        }
      })
      TotalOfTotalN.push(
        this.forTotal(janN),
        this.forTotal(febN),
        this.forTotal(marN),
        this.forTotal(aprN),
        this.forTotal(mayN),
        this.forTotal(juneN),
        this.forTotal(julyN),
        this.forTotal(augN),
        this.forTotal(sepN),
        this.forTotal(octN),
        this.forTotal(novN),
        this.forTotal(decN)
      )
      TotalOfTotalC.push(
        this.forTotal(janC),
        this.forTotal(febC),
        this.forTotal(marC),
        this.forTotal(aprC),
        this.forTotal(mayC),
        this.forTotal(juneC),
        this.forTotal(julyC),
        this.forTotal(augC),
        this.forTotal(sepC),
        this.forTotal(octC),
        this.forTotal(novC),
        this.forTotal(decC)
      )
      // TotalOfTotal.push(showData['list'])
      showData['TotalC'] = TotalOfTotalC
      showData['TotalN'] = TotalOfTotalN
      showData['TotalOfTotalC'] = this.forTotal(TotalOfTotalC)
      showData['TotalOfTotalN'] = this.forTotal(TotalOfTotalN)
      this.listShowTable.push(showData)
    })
  }

  get ws_data_toExcel() {
    const ws_data = [];
    this.listShowTable.map(ls => {
      if (ls.cla !== 'hide') {
        ws_data.push([ls.division]);

      } else {
        ws_data.push([...this.listHeader]);
        ls.list.map(item => {
          ws_data.push([
            item.team,
            item.case,
            item.mont1,
            item.mont2,
            item.mont3,
            item.mont4,
            item.mont5,
            item.mont6,
            item.mont7,
            item.mont8,
            item.mont9,
            item.mont10,
            item.mont11,
            item.mont12,
            item.total,
          ]);
        })

        if (ls.cla === 'hide') {
          ws_data.push(['Total', 'New case', ...ls.TotalN, ls.TotalOfTotalN]);
          ws_data.push(['', 'Continue case', ...ls.TotalC, ls.TotalOfTotalC]);
        }
      }

    });

    return ws_data;
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/ae-summary-visit-summary-by-team/ae-summary-visit-summary-by-team.component.ts